import {PlatformUtils} from "@app/core/shared/domain/platform.utils";
import {Injectable} from "@angular/core";

/**
 * Use case for checking if the application is running on a mobile platform (iOS or Android).
 * If the app is running on a mobile device or a web browser on a mobile, it returns true.
 */
@Injectable({
    providedIn: 'root'
})
export class GetIsMobileUseCase {
    constructor(private platformUtils:PlatformUtils) {
    }

    /**
     * Checks if the application is running on a mobile platform (iOS, Android, or mobile web).
     * If the app is running on a mobile device or a web browser on a mobile, it returns true.
     * @returns {boolean} - True if the app is running on a mobile platform or mobile web.
     */
    execute(): boolean {
        return this.platformUtils.isMobile;
    }
}